import React from 'react';
import {
	useCurrentFrame,
	useVideoConfig,
} from 'remotion';

import { linearTiming, TransitionSeries } from "@remotion/transitions";
import { slide } from "@remotion/transitions/slide";
import { fade } from "@remotion/transitions/fade";
import { wipe } from "@remotion/transitions/wipe";
import { flip } from "@remotion/transitions/flip";
import { clockWipe } from "@remotion/transitions/clock-wipe";
import { iris } from "@remotion/transitions/iris";
import { cube } from "../extras/cube";
import { FancyTextBlock } from "./FancyTextBlock";
import { TextItem } from "./TextBlock";

type TransitionType = 'slide' | 'fade' | 'wipe' | 'flip' | 'clockWipe' | 'iris' | 'cube';


export const TextCarousel: React.FC<{
	primaryColor?: string;
	secondaryColor?: string;
	/** Duration in frames (integer) */
	durationInFrames?: number;
	texts: TextItem[];
	transitionType: TransitionType;
}> = ({
	texts,
	transitionType,
}) => {
	const { fps } = useVideoConfig();


	const getTransitionPresentation = (type: TransitionType) => {
		switch (type) {
			case 'slide':
				return slide();
			case 'fade':
				return fade();
			case 'wipe':
				return wipe();
			case 'flip':
				return flip();
			case 'clockWipe':
				return clockWipe({ width: 1920, height: 1080 });
			case 'iris':
				return iris({ width: 1920, height: 1080 });
			case 'cube':
				return cube({ direction: "from-right", perspective: 1000 });
			default:
				return fade(); // Default to fade instead of null
		}
	};

	return (
		<TransitionSeries>
			{texts.map((textItem, index) => {
				// Get duration from d parameter or default to 3 seconds
				const durationMs = textItem.conf?.d || 3000;
				const framesForThisText = Math.ceil((durationMs / 1000) * fps);
				const transitionDuration = Math.ceil(0.001 * fps); // 0.7 seconds

				return (
					<React.Fragment key={index}>
						<TransitionSeries.Sequence durationInFrames={framesForThisText}>
							<FancyTextBlock textItem={textItem} />
						</TransitionSeries.Sequence>
						{index < texts.length - 1 && (
							<TransitionSeries.Transition
								presentation={getTransitionPresentation(transitionType)}
								timing={linearTiming({ durationInFrames: transitionDuration })}
							/>
						)}
					</React.Fragment>
				);
			})}
		</TransitionSeries>
	);
};

;
    var _remotion_globalVariableA, _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
